import { UntypedFormGroup } from '@angular/forms';

export const FormResetManyHelper = (form: UntypedFormGroup, controls: string[]) => {
  controls.forEach(x => {
    form.controls[x].reset();
  });
};
